// extracted by css-extract-rspack-plugin
export default {"spinnerWrapper":"_4dfb5b14","withDimBackground":"_a0fd09f6"};